import React from 'react';

export default function FeedbackBugDetails({ item }) {
  if (item.type !== 'bug') return null;
  
  const hasDetails = item.steps_to_reproduce || item.expected_behavior || item.actual_behavior;
  if (!hasDetails) return null;

  return (
    <div className="mt-3 space-y-2 text-sm bg-slate-800/50 rounded-lg p-3 border border-slate-700/50">
      {item.steps_to_reproduce && (
        <div>
          <span className="text-slate-400 font-medium text-xs uppercase tracking-wider">Steps to Reproduce</span>
          <p className="text-slate-200 whitespace-pre-wrap mt-1">{item.steps_to_reproduce}</p>
        </div>
      )}
      {item.expected_behavior && (
        <div>
          <span className="text-emerald-400/80 font-medium text-xs uppercase tracking-wider">Expected Behavior</span>
          <p className="text-slate-200 whitespace-pre-wrap mt-1">{item.expected_behavior}</p>
        </div>
      )}
      {item.actual_behavior && (
        <div>
          <span className="text-red-400/80 font-medium text-xs uppercase tracking-wider">Actual Behavior</span>
          <p className="text-slate-200 whitespace-pre-wrap mt-1">{item.actual_behavior}</p>
        </div>
      )}
    </div>
  );
}